import {
  MicrosoftTeamsMessageAttachment,
  MicrosoftTeamsMessageAttachmentForwardedMessage,
  MicrosoftTeamsMessageAttachmentMeetingReference,
  MicrosoftTeamsMessageAttachmentMessageReference,
} from "@cohesive/api-entities";

if (typeof window !== "undefined") {
  class EmojiElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // Only set once
      if (!this.innerText) {
        const alt = this.getAttribute("alt");
        if (alt) {
          this.innerText = alt;
        }
      }
    }
  }

  function isMessageReference(
    content: MicrosoftTeamsMessageAttachment["content"],
  ): content is MicrosoftTeamsMessageAttachmentMessageReference {
    return !!content && "messageId" in content;
  }

  function isForwardedMessage(
    content: MicrosoftTeamsMessageAttachment["content"],
  ): content is MicrosoftTeamsMessageAttachmentForwardedMessage {
    return !!content && "originalMessageId" in content;
  }

  function isMeetingReference(
    content: MicrosoftTeamsMessageAttachment["content"],
  ): content is MicrosoftTeamsMessageAttachmentMeetingReference {
    return !!content && "exchangeId" in content;
  }

  class AttachmentElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const attachment = JSON.parse(
        this.getAttribute("data-attachment") || "{}",
      ) as MicrosoftTeamsMessageAttachment;

      if (attachment) {
        if (isMessageReference(attachment.content)) {
          this.innerHTML = `
            <blockquote class="border-l-2 italic pl-2 mb-2">
              <cite class="text-xs font-medium">${attachment.content?.messageSender.user.displayName}</cite>
              <p class="text-xs text-muted-foreground">${attachment.content?.messagePreview}</p>
            </blockquote>
          `;
        }

        if (isForwardedMessage(attachment.content)) {
          this.innerHTML = `
            <blockquote class="border-l-2 italic pl-2 mb-2">
              <cite class="text-xs font-medium">${attachment.content?.originalMessageSender.user.displayName}</cite>
              <p class="text-xs text-muted-foreground">${attachment.content?.originalMessageContent}</p>
            </blockquote>
          `;
        }

        if (isMeetingReference(attachment.content)) {
          this.innerHTML = `
            <blockquote class="border-l-2 italic pl-2 mb-2">
              <cite class="text-xs font-medium">${attachment.content?.organizerId}</cite>
              <p class="text-xs text-muted-foreground">${attachment.content?.exchangeId}</p>
            </blockquote>
          `;
        }

        if (attachment.content_type === "reference" && attachment.content_url) {
          this.innerHTML = `
            <img src="${attachment.content_url}" alt="Thumbnail" class="w-full h-auto" />
          `;
        }
      }
    }
  }

  customElements.define("x-attachment", AttachmentElement);
  customElements.define("x-emoji", EmojiElement);
}
